import { useState } from 'react';
import { useNavigate } from 'react-router';
import { RoutePaths } from './../../constants';
import { ErrorContent } from './ErrorContent/ErrorContent';
import { FormContent } from './FormContent/FormContent';
import { SuccessContent } from './SuccessContent/SuccessContent';
import { Modal } from 'components';
import { useCreatePatient } from 'hooks';
import { PatientCase } from 'types';

export const CreatePatientCaseModal = () => {
  const [createdPatientCase, setCreatedPatientCase] = useState<PatientCase | null>(null);
  const [displayError, setDisplayError] = useState(false);

  const { closeModalHandler } = useCreatePatient();

  const navigate = useNavigate();

  const close = () => {
    closeModalHandler();
  };

  const handleConfirm = () => {
    if (createdPatientCase) {
      navigate(`${RoutePaths.PATIENTS}/${createdPatientCase.id}`);
    }
  };

  return (
    <Modal onClose={close} title="Create a new patient">
      {displayError ? (
        <ErrorContent onConfirm={close} />
      ) : createdPatientCase ? (
        <SuccessContent handleConfirm={handleConfirm} onClose={close} />
      ) : (
        <FormContent onClose={close} setCreatedPatientCase={setCreatedPatientCase} setDisplayError={setDisplayError} />
      )}
    </Modal>
  );
};
